var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_349_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.674927H22V22.6036H0V0.674927Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_349_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.753 10.7039C21.865 10.7039 22.3815 9.45439 21.5505 8.78752L17.5019 5.54939L11.8507 1.02994C11.3995 0.663848 10.7198 0.663848 10.2677 1.02994L5.17249 5.09822V1.94604H2.3735V7.34205L0.567958 8.78752C-0.262198 9.45439 0.254286 10.7039 1.36632 10.7039V22.5616H20.759V12.9211H20.753V10.7039ZM16.6323 15.6685C16.6323 15.9298 16.3968 16.1455 16.1089 16.1455H13.8462C13.5583 16.1455 13.3228 16.3552 13.3228 16.6233V18.6832C13.3228 18.9453 13.0873 19.161 12.7994 19.161H9.31983C9.03194 19.161 8.79647 18.9453 8.79647 18.6832V16.6233C8.79647 16.3552 8.561 16.1455 8.27311 16.1455H6.01038C5.72249 16.1455 5.48702 15.9298 5.48702 15.6685V12.5026C5.48702 12.2405 5.72249 12.0248 6.01038 12.0248H8.27311C8.561 12.0248 8.79647 11.8091 8.79647 11.5478V9.48705C8.79647 9.2258 9.03194 9.0101 9.31983 9.0101H12.7994C13.0873 9.0101 13.3228 9.2258 13.3228 9.48705V11.5478C13.3228 11.8091 13.5583 12.0248 13.8462 12.0248H16.1089C16.3968 12.0248 16.6323 12.2405 16.6323 12.5026V15.6685Z",
    fill: "#344054"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/Hospital.111ed61621178639a6f19b6bb9714b2d.svg";
export { ForwardRef as ReactComponent };